import React, { useState, useEffect } from 'react';
import Menu from './Menu';
import apiCall from '../../utils/api';
import {
  ContentContainer,
  ProfileCard,
  Title,
  InfoItem,
  UaiList,
  UaiItem,
  LogoutButton,
  LoadingText,
  ModalOverlay,
  ModalBox,
  ModalMessage,
  ModalButtonContainer,
  ConfirmButton,
  CancelButton,
  ShowMoreButton
} from './ProfileStyles';
import theme from '../../theme';

const Profile = ({ onLogout }) => {
  const [managerData, setManagerData] = useState(null);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [visibleEstablishmentsCount, setVisibleEstablishmentsCount] = useState(20);

  useEffect(() => {
    const fetchManagerData = async () => {
      try {
        const data = await apiCall(
          `${process.env.REACT_APP_BACKEND_URL}/manager/me/`,
          'GET'
        );
        setManagerData(data);
      } catch (error) {
        console.error("Failed to fetch manager data:", error);
        // Optionally, handle error state in the UI
      }
    };

    fetchManagerData();
  }, []);


  if (!managerData) {
    return (
      <Menu>
        <ContentContainer>
          <LoadingText>Chargement des données du manager...</LoadingText>
        </ContentContainer>
      </Menu>
    );
  }

  const establishments = managerData.establishments || [];

  const handleShowMore = () => {
    setVisibleEstablishmentsCount(prevCount => prevCount + 20);
  };

  return (
    <Menu> {/* Wrap content with the Manager Menu */}
      <ContentContainer>
        <ProfileCard>
          <Title>Profil Manager</Title>
          <InfoItem>
            <strong>Email:</strong> {managerData.email}
          </InfoItem>
          <InfoItem>
            <strong>Établissements associés:</strong>
            {establishments.length === 0 ? (
              <LoadingText style={{ fontStyle: 'normal', color: theme.colors.gris_moyen }}>Aucun établissement associé.</LoadingText>
            ) : (
              <>
                <UaiList>
                  {establishments.slice(0, visibleEstablishmentsCount).map((establishment) => (
                    <UaiItem key={establishment.uai}>
                      {establishment.uai} ({establishment.name || 'Nom inconnu'})
                    </UaiItem>
                  ))}
                </UaiList>
                {establishments.length > visibleEstablishmentsCount && (
                  <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                    <ShowMoreButton onClick={handleShowMore}>
                      Voir plus
                    </ShowMoreButton>
                  </div>
                )}
              </>
            )}
          </InfoItem>
          <LogoutButton onClick={() => setShowLogoutConfirm(true)}>
            Se déconnecter
          </LogoutButton>
        </ProfileCard>
      </ContentContainer>
      
      {/* Render the custom modal */}
      {showLogoutConfirm && (
        <ModalOverlay onClick={() => setShowLogoutConfirm(false)}>
          {/* Stop propagation prevents closing modal when clicking inside the box */}
          <ModalBox onClick={(e) => e.stopPropagation()}>
            <ModalMessage>
              Êtes-vous sûr de vouloir vous déconnecter ?
            </ModalMessage>
            <ModalButtonContainer>
              <CancelButton onClick={() => setShowLogoutConfirm(false)}>
                Annuler
              </CancelButton>
              <ConfirmButton onClick={() => {
                // Clear manager-related data from localStorage
                localStorage.removeItem('managerData');
                // Also remove token if stored (adjust key if necessary)
                localStorage.removeItem('access_token'); 
                
                // Call the original logout handler (passed as prop)
                onLogout();
                setShowLogoutConfirm(false); // Close modal after action
              }}>
                Se déconnecter
              </ConfirmButton>
            </ModalButtonContainer>
          </ModalBox>
        </ModalOverlay>
      )}
    </Menu>
  );
};

export default Profile; 